// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"6f769adaa5903de81eaf","339":"02f27ab4e1eaad4254ae"}[chunkId] + ".js";
};